import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AnalyseFundServices from "./AnalyseCompanyFundServices";
import { toast } from "react-toastify";
import { successAlert, successAlertOff } from "../../Global/GlobalSlice";

//GLOBAL THUNK
export const GetGlobalData = createAsyncThunk(
  "analyse_fund/get_global_data",
  async (arg, { rejectWithValue, getState, dispatch }) => {
    try {
      const returnResponseData = async () => {
        let Banks = await AnalyseFundServices.FetchAccounts();
        console.log({ Banks });
        return {
          Banks,
        };
      };

      const responseData = returnResponseData();

      return responseData;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Cashbook thunks
export const PreviewBankStatementThunk = createAsyncThunk(
  "cost_center/previewBankStatement",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.UploadBankStatement(data);
      if (responseData?.successful === true) {
        // dispatch(
        //   successAlert({
        //     message: responseData?.statusMessage,
        //   })
        // );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData?.responseObject;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const UploadBankStatementThunk = createAsyncThunk(
  "cost_center/uploadBankStatement",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.FinalUploadBankStatement(
        data
      );
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData?.responseObject;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetCashbook = createAsyncThunk(
  "cost_center/get_cashbook",
  async (
    query = { pageSize: 100, pageNumber: 1 },
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
      const data = await AnalyseFundServices.getCashbook(query);
      return data?.responseObject;
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return [] || rejectWithValue(error?.response?.data);
    }
  }
);

// Investment thunks
export const RecommendInvestment = createAsyncThunk(
  "analyse_funds/recommend_investment",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.createRecommendation(data);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message:
              responseData?.data?.statusMessage ?? responseData.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData;
    } catch (error) {
      console.log({ errorInInvestmentSlice: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const ApproveInvestment = createAsyncThunk(
  "cost_center/approve_investment",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.approveRecommendation(
        data
      );
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const DeclineInvestment = createAsyncThunk(
  "cost_center/decline_investment",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.declineRecommendation(
        data
      );
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetRecommendations = createAsyncThunk(
  "cost_center/get_recommendations",
  async (
    data = { pageNumber: 1, pageSize: 100 },
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
      const responseData = await AnalyseFundServices.getAllRecommendations(
        data
      );

      console.log({ responseData });
      // if (responseData?.successful === true) {
      //     toast.success(responseData?.statusMessage);
      // } else if (responseData?.statusMessage) {
      //   toast(responseData?.statusMessage)
      // }
      return responseData;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const UpdateRecommendation = createAsyncThunk(
  "cost_center/update_recommendation",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.editRecommendation(data);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const CancelRecommendation = createAsyncThunk(
  "cost_center/cancel_recommendation",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.cancelRecommendation(data);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Keywords Thunk
export const CreateKeywords = createAsyncThunk(
  "analyse_funds/create_keyword",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.createKeyword(formData);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
        return responseData?.data;
      }
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const PreviewKeywordBatchThunk = createAsyncThunk(
  "cost_center/previewKeywordBatch",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.previewKeywordBatchUpload(
        data
      );
      if (responseData?.successful === true) {
        // dispatch(
        //   successAlert({
        //     message: responseData?.statusMessage,
        //   })
        // );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData?.responseObject?.treasuryKeyword;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const UploadKeywordBatchThunk = createAsyncThunk(
  "cost_center/uploadKeywordBatch",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.finaliseKeywordBatchUpload(
        data
      );
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData?.responseObject;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const UpdateKeywords = createAsyncThunk(
  "analyse_funds/update_keyword",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.updateKeyword(formData);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
        return responseData?.data;
      }
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetKeywords = createAsyncThunk(
  "analyse_funds/get_keyword",
  async (
    query = { pageSize: 10, pageNumber: 1 },
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
      console.log({ query });
      const data = await AnalyseFundServices.getKeywords(query);
      return data;
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const DeleteKeywords = createAsyncThunk(
  "analyse_funds/delete_keyword",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.deleteKeyword(formData);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
        return responseData?.data;
      }
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//HOD THUNKS
export const ApproveRecommendation = createAsyncThunk(
  "analyse_funds/approveRecommendation",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.approveRecommendation(
        data
      );
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const DeclineRecommendation = createAsyncThunk(
  "cost_center/createNewClass",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.createClass(data);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ViewInvestments = createAsyncThunk(
  "cost_center/createNewClass",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await AnalyseFundServices.createClass(data);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
      }
      return responseData?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  AnalyseFundServices: {},
  SelectedService: {},
  CostCenterClass: {},
  SelectedClass: {},
  GlobalData: {},
  editMode: false,
  isLoading: false,
  error: null,
  Recommendations: [],
};

const reducers = {
  viewRecommendation(state, action) {
    return { ...state, SelectedRecommendation: action.payload };
  },
  viewKeyword(state, action) {
    return { ...state, SelectedKeyword: action.payload };
  },
  setEditMode(state, action) {
    return { ...state, editMode: action.payload };
  },
};

export const RequestSlice = createSlice({
  name: "analyse_company_fund",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(GetCashbook.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetCashbook.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          CashBook: action.payload,
        };
      })
      .addCase(GetCashbook.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder
      .addCase(GetKeywords.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetKeywords.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          Keywords: action.payload,
        };
      })
      .addCase(GetKeywords.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          Keywords: [],
          error: action.payload,
        };
      });

    builder.addCase(GetGlobalData.fulfilled, (state, action) => ({
      ...state,
      GlobalData: action.payload,
    }));

    builder.addCase(GetRecommendations.pending, (state) => {
      return {
        ...state,
        isLoading: true, // Set loading state without wiping Recommendations
      };
    });

    builder.addCase(GetRecommendations.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false, // Reset loading state on error
        error: action.payload, // Capture the error
      };
    });

    builder.addCase(GetRecommendations.fulfilled, (state, action) => {
      console.log("Recommendations data:", action.payload); // Debugging
      return {
        ...state,
        isLoading: false,
        Recommendations: action.payload,
      };
    });
  },
});

export const { setEditMode, viewRecommendation, viewKeyword } =
  RequestSlice.actions;

export default RequestSlice.reducer;
